import * as CourseListI from "./CourseList";
import * as DSPermissionI from "./DSPermission";
import * as EmployeeDocumentI from "./EmployeeDocument";
import * as EmployeeHistoryI from "./EmployeeHistory";
import * as EmployeeInfoI from "./EmployeeInfo";
import * as EmployeeListI from "./EmployeeList";
import * as EmployeePaymentI from "./EmployeePayment";
import * as EmployeeSWHI from "./EmployeeSWH";
import * as EmployeeTAI from "./EmployeeTA";
import * as LeavePolicyI from "./LeavePolicy";
import * as PayrollI from "./Payroll";
import * as SelfServicePaySlipI from "./SelfServicePaySlip";
import * as SelfServiceScheduleI from "./SelfServiceSchedule";
import * as SetupWorkScheduleI from "./SetupWorkSchedule";
import * as SummaryTrainingKPII from "./SummaryTrainingKPI";
import * as TrainingHistoryI from "./TrainingHistory";
import * as TrainingKPISettingI from "./TrainingKPISetting";
import * as TrainingManagementI from "./TrainingManagement";
import * as WorkScheduleI from "./WorkSchedule";

export const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  CourseList: {
    default: {
      START: CourseListI.Start,
      Action: CourseListI.Action,
    },
  },
  DSPermission: {
    default: {
      START: DSPermissionI.Start,
      Action: DSPermissionI.Action,
    },
  },
  EmployeeDocument: {
    default: {
      START: EmployeeDocumentI.Start,
      Action: EmployeeDocumentI.Action,
    },
  },
  EmployeeHistory: {
    default: {
      START: EmployeeHistoryI.Start,
      Action: EmployeeHistoryI.Action,
    },
  },
  EmployeeInfo: {
    default: {
      START: EmployeeInfoI.Start,
      Action: EmployeeInfoI.Action,
    },
  },
  EmployeeList: {
    default: {
      START: EmployeeListI.Start,
      Action: EmployeeListI.Action,
    },
  },
  EmployeePayment: {
    default: {
      START: EmployeePaymentI.Start,
      Action: EmployeePaymentI.Action,
    },
  },
  EmployeeSWH: {
    default: {
      START: EmployeeSWHI.Start,
      Action: EmployeeSWHI.Action,
    },
  },
  EmployeeTA: {
    default: {
      START: EmployeeTAI.Start,
      Action: EmployeeTAI.Action,
    },
  },
  LeavePolicy: {
    default: {
      START: LeavePolicyI.Start,
      Action: LeavePolicyI.Action,
    },
  },
  Payroll: {
    default: {
      START: PayrollI.Start,
      Action: PayrollI.Action,
    },
  },
  SelfServicePaySlip: {
    default: {
      START: SelfServicePaySlipI.Start,
      Action: SelfServicePaySlipI.Action,
    },
  },
  SelfServiceSchedule: {
    default: {
      START: SelfServiceScheduleI.Start,
      Action: SelfServiceScheduleI.Action,
    },
  },
  SetupWorkSchedule: {
    default: {
      START: SetupWorkScheduleI.Start,
      Action: SetupWorkScheduleI.Action,
    },
  },
  SummaryTrainingKPI: {
    default: {
      START: SummaryTrainingKPII.Start,
      Action: SummaryTrainingKPII.Action,
    },
  },
  TrainingHistory: {
    default: {
      START: TrainingHistoryI.Start,
      Action: TrainingHistoryI.Action,
    },
  },
  TrainingKPISetting: {
    default: {
      START: TrainingKPISettingI.Start,
      Action: TrainingKPISettingI.Action,
    },
  },
  TrainingManagement: {
    default: {
      START: TrainingManagementI.Start,
      Action: TrainingManagementI.Action,
    },
  },
  WorkSchedule: {
    default: {
      START: WorkScheduleI.Start,
      Action: WorkScheduleI.Action,
    },
  },
};

export default SequencePattern;
